module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('blockquote', [_c('blockquote', [_c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FORGE BOOKS BY LARRY BOND")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Dangerous Ground")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Cold Choices")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FORGE BOOKS BY LARRY BOND"), _c('br'), _vm._v("AND JIM DEFELICE")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Larry Bond’s First Team")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Larry Bond’s First Team: Angels of Wrath")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Larry Bond’s First Team: Fires of War")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Larry Bond’s First Team: Soul of the Assassin")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79dfe612","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abouttheauthor.vue
// module id = 63
// module chunks = 0